// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=d02c6e20-d8d9-40e2-bb31-bb5c22095ec1";
};